import IconGearsSolid from '@/assets/icons/font_awesome/gears-solid.svg?react';
import IconTableCellsLargeSolid from '@/assets/icons/font_awesome/table-cells-large-solid.svg?react';
import { EPagesMobileTabs } from '@/enums/EPagesMobileTabs';
import { use_slice_search } from '@/hooks/store/use_slices';
import { TabsContent } from '@radix-ui/react-tabs';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { useState } from 'react';
import { LayoutPageMobileWithTabs } from '../../layouts/LayoutPageMobileWithTabs';
import { GRID2D__master } from '../_base/grid2d/views/GRID2D__master';
import { SidebarSearch } from './SidebarSearch';

export function PageSearchViewsMobile() {
  //FIELDS

  const { search_current } = use_slice_search(['search_current']);

  const [activeTab, setActiveTab] = useState(EPagesMobileTabs.SEARCH_SETTINGS);
  /*
   * HTML
   */
  return (
    <>
      <LayoutPageMobileWithTabs
        tabs={[EPagesMobileTabs.SEARCH_SETTINGS, EPagesMobileTabs.GRID2D]}
        icons={[<IconGearsSolid />, <IconTableCellsLargeSolid />]}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      >
        <TabsContent className={`mt-0 !max-h-[calc(100vh-7.5rem)] h-[calc(100vh-7.5rem)]`} value={EPagesMobileTabs.SEARCH_SETTINGS}>
          <SidebarSearch />
        </TabsContent>
        <TabsContent className={`mt-0 !max-h-[calc(100vh-7.5rem)] h-[calc(100vh-7.5rem)]`} value={EPagesMobileTabs.GRID2D}>
          <div className="w-full h-full text-center relative flex flex-col">
            <GRID2D__master entity_type={ENUM__workspace_entity.ENTITY_SEARCH} entity_id={search_current._id} />
          </div>
        </TabsContent>
      </LayoutPageMobileWithTabs>
    </>
  );
}
